__webpack_require__.p = "https://assets-01.periodica.press/dc3b333-21902332254/";